export default $axios => resource => ({
	login(payload) {
		return $axios.post(`${resource}`, payload)
	},
})
